
import PropTypes from "prop-types";
import classNames from "classnames";

const prefix = "t-app-container";

const AppContainer = ({
  alignContent,
  alignItems,
  justifyContent,
  children
}) => {
  const classForComponent = classNames(prefix, "flex box-border min-h-[100%]");

  const classForChild = classNames("container flex flex-wrap mx-auto", {
    [`content-${alignContent}`]: alignContent,
    [`items-${alignItems}`]: alignItems,
    [`justify-${justifyContent}`]: justifyContent
  })

  return (
    <div className={classForComponent}>
      <div className={classForChild} style={{alignItems: "center"}}>
        {children}
      </div>
    </div>
  );
};

AppContainer.propTypes = {
  alignContent: PropTypes.oneOf(["normal", "center", "start", "end", "between", "around", "evenly", "baseline", "stretch"]),
  alignItems: PropTypes.oneOf(["start", "end", "center", "baseline", "stretch"]),
  justifyContent: PropTypes.oneOf(["normal", "center", "start", "end", "between", "around", "evenly", "stretch"]),
};

export default AppContainer;
